import { createEffect } from 'effector'

import { getTotalAccountValueData } from './api'

export const getTotalAccountValueFx = createEffect(async () => {
  const data = await getTotalAccountValueData()
  return data
})
